export const Alignment = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
};

export const Size = {
  XXSMALL: "xxsmall",
  XSMALL: "xsmall",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
  XLARGE: "xlarge",
};
